/* eslint-disable semi */
/* eslint-disable no-undef */
(function () {
  angular.module('MktzapApp.Controllers')
    .controller('CompanyEmployerController', companyEmployer);

  companyEmployer.$inject = ['NotificationService', 'CompanyEmployerService', 'FoundationApi', 'LangService'];

  function companyEmployer (NotificationService, CompanyEmployerService, FoundationApi, LangService) {
    var vm = this;
    vm.page = 'create';
    vm.companyEmployer = {};
    vm.companyEmployerList = [];
    vm.index = null;

    LangService
      .getPageLabels({ 'page': 'menu.channelsPlugin.companyEmployer' })
      .$promise
      .then(function (data) {
        vm.labels = data.lang;
      });

    loadCompaniesEmployers();

    function loadCompaniesEmployers () {
      if (vm.page === 'create') {
        vm.companyEmployer = {};
        CompanyEmployerService
          .all()
          .$promise
          .then(function (data) {
            vm.companyEmployerList = data;
          })
          .catch(function (error) {
            NotificationService.errorHandler(error, 'error');
          })
      } else if (vm.page === 'employers' && vm.companyEmployerId) {
        vm.edit(vm.companyEmployerId);
      }
    }

    vm.save = function () {
      const validation = validateFields();

      if (!validation) {
        return;
      }

      return vm.companyEmployer._id === undefined
        ? create()
        : update();
    }

    function create () {
      CompanyEmployerService
        .create({}, vm.companyEmployer)
        .$promise
        .then(function (data) {
          loadCompaniesEmployers();
          NotificationService.successHandler(data, vm.labels.savedWithSuccess);
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, vm.labels.error);
        });
    }

    function update () {
      CompanyEmployerService
        .update({
          id: vm.companyEmployer._id,
          employerIndex: vm.employerIndex
        }, vm.companyEmployer)
        .$promise
        .then(function (data) {
          loadCompaniesEmployers();
          vm.employerIndex = null;
          NotificationService.successHandler(data, vm.labels.updatedWithSuccess);
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, vm.labels.error);
        });
    }

    vm.edit = function (companyEmployerId) {
      CompanyEmployerService
        .findOne({
          id: companyEmployerId
        })
        .$promise
        .then(function (data) {
          vm.companyEmployer = data;
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, vm.labels.error);
        });
    }

    vm.deleteCompanyEmployerModal = function (companyEmployer, index) {
      vm.deletingCompanyEmployer = companyEmployer;
      vm.index = index;
      FoundationApi.publish('deleteCompanyEmployerModal', 'open');
    }

    vm.delete = function (companyEmployer, index) {
      CompanyEmployerService
        .delete({
          id: companyEmployer._id
        })
        .$promise
        .then(function (data) {
          vm.companyEmployerList.splice(index, 1);
          NotificationService.successHandler(data, vm.labels.successDelData);
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, vm.labels.error);
        });

      vm.deletingCompanyEmployer = null;
      FoundationApi.publish('deleteCompanyEmployerModal', 'close');
    }

    vm.goToEmployersPage = function (companyEmployerId) {
      vm.page = 'employers';
      vm.companyEmployer.employer = {};

      CompanyEmployerService
        .findOne({
          id: companyEmployerId
        })
        .$promise
        .then(function (data) {
          vm.companyEmployer = data;
          vm.companyEmployerId = companyEmployerId;
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, vm.labels.error);
        });
    }

    vm.editEmployer = function (index) {
      vm.companyEmployer.employer = angular.copy(vm.companyEmployer.employers[index]);
      vm.employerIndex = index;
    }

    vm.deleteEmployerModal = function (employer, index) {
      vm.employer = employer;
      vm.employerIndex = index;
      FoundationApi.publish('deleteEmployerModal', 'open');
    }

    vm.deleteEmployer = function (index) {
      CompanyEmployerService
        .deleteEmployer({
          companyEmployer: vm.companyEmployer,
          employerIndex: index
        })
        .$promise
        .then(function (data) {
          vm.employerIndex = null;
          loadCompaniesEmployers();
          NotificationService.successHandler(data, vm.labels.successDelData);
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, vm.labels.error);
        });

      vm.employer = null;
      FoundationApi.publish('deleteEmployerModal', 'close');
    }

    vm.goToCreatePage = function () {
      vm.page = 'create';
      vm.companyEmployer = {};
    }

    function validateFields () {
      if (vm.page === 'create') {
        if (
          !vm.companyEmployer.description ||
          vm.companyEmployer.description.length === 0
        ) {
          NotificationService.warningHandler(null, vm.labels.errorFillDescriptionField);
          return false;
        }
      }

      if (vm.page === 'employers') {
        if (
          !vm.companyEmployer.employer ||
          !vm.companyEmployer.employer.description ||
          vm.companyEmployer.employer.description.length === 0
        ) {
          NotificationService.warningHandler(null, vm.labels.errorFillDescriptionField);
          return false;
        }
      }

      return true;
    }
  }
// eslint-disable-next-line semi
})();
